// Re-export from tpmReducer for backwards compatibility
export { initialState, REQUEST_TIMEOUT, CODE_EXPIRY } from './tpmReducer';

// Legacy initial state shape (deprecated - use tpmReducer.initialState)
export const legacyInitialState = {
    number: '',
    status: 'IDLE',
    error: '',
    touched: false,
};

export const path = {
    /** @type {'/sms-authorization'} */
    SMS_AUTHORIZATION: '/sms-authorization',
    /** @type {'/associated-accounts'} */
    ASSOCIATED_ACCOUNTS: '/associated-accounts',
    /** @type {'/dashboard-services'} */
    DASHBOARD_SERVICES: '/dashboard-services',
};

export const QUEUE_LIMIT = 30 * 60; // 30 minutes
export const delay = 20 * 1000;
export const MIN_REQUEST_INTERVAL = 15 * 60 * 1000; // 15 minutes in ms

export const trialEndInstructionBody = [
    'Your trial has expired and calling services may be disabled.',
    'Please contact your provider.',
];

export const noAssociatedInstructionBody = [
    'Please Enter your Mobile Phone Number above to verify with the Operator if TPM is supported.',
    'Please note, this may take up to 15 minutes after submitting your number.',
];

export const associatedInstructionBody = [
    'There is already an Active Mobile Account associated with your organisation.',
    // 'If the Mobile Phone Number you are looking to enable for Teams Phone Mobile belongs to this account, click Back to activate.',
    'If you would like to add a new account, please continue to enter the Mobile Phone number above to start the verification process.',
];

export const PHONE_INVALID_FORMAT =
    'Phone number contains invalid characters. Please ensure you are using E.164 format.';

export const operatorInstruction = [
    'The Mobile Operator is processing your request.',
    'This may take up to 15 minutes. This screen shall auto refresh,',
    'You may navigate away from this screen and come back to it later if required.',
    'Resubmitting your number for validation does not restart the process.',
];

export const noAssociatedInstructionBodyNumbersPage = [
    'There is no Active Mobile Account associated with your organisation. Please associate an account to enable Teams Phone Mobile.',
];

export const keywords = [
    'Mobile Phone Number',
    'TPM',
    '15 minutes',
    'Back',
    'Teams Phone Mobile',
    'Active Mobile Account',
    'has expired',
    'disabled',
];

export const helperText =
    'To associate a new account to this company, please provide a mobile number belonging to the account below.';

export const phoneInputStyles = (show, isNextButtonDisabled) => ({
    '.react-tel-input .flag-dropdown': {
        background: 'white',
        border: `1px solid ${show && isNextButtonDisabled ? 'var(--chakra-colors-red-500)' : 'var(--chakra-colors-gray-300)'}`,
    },
    '.react-tel-input input.form-control': {
        border: `1px solid ${show && isNextButtonDisabled ? 'var(--chakra-colors-red-500)' : 'var(--chakra-colors-gray-300)'}`,
        '&:focus': {
            boxShadow: `0 0 0 .1rem ${show && isNextButtonDisabled ? 'var(--chakra-colors-red-500)' : 'var(--chakra-colors-primary-500)'}`,
        },
        boxShadow: `${show && isNextButtonDisabled ? '0 0 0 .1rem var(--chakra-colors-red-500)' : ''}`,
    },
    '.react-tel-input .country-list .country-name': {
        color: '#6B6B6B',
    },
});
